import { render, staticRenderFns } from "./GameCardsStack.vue?vue&type=template&id=3c41d86c&scoped=true"
import script from "./GameCardsStack.vue?vue&type=script&lang=js"
export * from "./GameCardsStack.vue?vue&type=script&lang=js"
import style0 from "./GameCardsStack.vue?vue&type=style&index=0&id=3c41d86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c41d86c",
  null
  
)

export default component.exports